import { Box } from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { FontStyle, JobClickType, JobDisplays } from "../../constants";
import DescriptionOverlay from "./DescriptionOverlay";
import InnerVid from "./InnerVid";

export const defaultVidHeightOverWidth = 1.7898;
const startupSec = 0.3;

const styles = {
  container: {
    zIndex: 1,
    width: "100%",
    minWidth: "",
    ...FontStyle.body,
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    cursor: "pointer",
    position: "relative",
  },
  videoSizer: {
    width: "100%",
    cursor: "pointer",
  },
  videoInner: (loadPct, vidHeightOverWidth) => {
    return {
      position: "relative",
      width: "100%",
      paddingBottom: `${vidHeightOverWidth * Math.min(100, 100 * loadPct)}%`,
      height: 0,
      borderRadius: JobDisplays.borderRadius,
      overflow: "hidden",
    };
  },
  videoStyle: {
    position: "absolute",
    top: "0%",
    left: "-1%",
    width: "102%",
    height: "100%",
    pointerEvents: "none",
  },
};

const srcOptions =
  "&enablejsapi&mute=1&controls=0&loop=1&showinfo=0&autohide=1";

const JobResourceVid = (
  {
    src,
    active,
    setMainSrc,
    mainSrc,
    showDescriptionOverlay = "",
    spacing,
    ytScriptLoaded, // (bool), since we manually load yt script
    setYtScriptLoaded = null, // for the video designated to load script
    setTutSizes = null,
    vidHeightOverWidth = defaultVidHeightOverWidth,
    logClick = () => {},
  },
  ref = null
) => {
  // const [fullSrc, setFullSrc] = React.useState(null);
  const [autoplay, setAutoplay] = React.useState(true);
  const [loadPct, setLoadPct] = React.useState(0);
  const [expandTimer, setExpandTimer] = React.useState(null);
  const [collapseTimer, setCollapseTimer] = React.useState(null);
  const fullSrc =
    `https://www.youtube.com/embed/${src}?playlist=${src}&autoplay=1` +
    srcOptions;

  // handle collapse/expand effects when "active" is toggled by parent
  useEffect(() => {
    if (expandTimer) clearInterval(expandTimer);
    if (collapseTimer) clearInterval(collapseTimer);

    if (active) {
      setExpandTimer(
        setInterval(() => {
          setLoadPct((loadPct) => loadPct + 4 / 60);
        }, 1000 / 60)
      );
    } else {
      setCollapseTimer(
        setInterval(() => {
          setLoadPct((loadPct) => loadPct - 4 / 60);
        }, 1000 / 60)
      );
    }
  }, [active]);

  // stop animation when loadPct reaches 1 or 0
  useEffect(() => {
    if (active && loadPct >= 1 && expandTimer) {
      clearInterval(expandTimer);
    }
    if (!active && loadPct <= 0 && collapseTimer) {
      clearInterval(collapseTimer);
    }
  }, [loadPct, expandTimer, active]);

  return (
    <Box
      sx={{
        ...styles.container,
        ...styles.videoSizer,
        opacity: active && loadPct >= 1 ? 1 : 0,
        ...(!active && { marginBottom: -spacing }),
      }}
      onClick={() => {
        setMainSrc(src);
        logClick({ clickType: JobClickType.video, clickId: src });
      }}>
      {active && loadPct >= 1 && (
        <DescriptionOverlay visible={showDescriptionOverlay} name="content" />
      )}
      <Box sx={styles.videoInner(loadPct, vidHeightOverWidth)} ref={ref}>
        {fullSrc &&
          // loadPct >= 1 && // loadPct>=1 disabled when using "InnerVid" as it causes some error
          (setYtScriptLoaded !== null || ytScriptLoaded) && (
            // <iframe
            //   ref={ref}
            //   style={styles.videoStyle}
            //   src={fullSrc}
            //   title="YouTube video player"
            //   allow="autoplay;"
            //   frameBorder="0"
            // />
            <InnerVid
              loadPct={loadPct}
              src={src}
              setYtScriptLoaded={setYtScriptLoaded}
              ytScriptLoaded={ytScriptLoaded}
            />
          )}
      </Box>
    </Box>
  );
};

// export default JobResourceVid;
export default React.forwardRef(JobResourceVid);
